import { ConnectSymbol } from './types';
var Connectable = /** @class */ (function () {
    function Connectable(scheduler) {
        this.scheduler = scheduler;
        this._connector = null;
    }
    Object.defineProperty(Connectable.prototype, "_isConnected", {
        get: function () {
            return Boolean(this._connector);
        },
        enumerable: true,
        configurable: true
    });
    Connectable.prototype[ConnectSymbol] = function (connector) {
        var _this = this;
        if (this._isConnected) {
            throw Error('Only one connector is allowed to connect!');
        }
        this._connector = connector;
        this.onConnected();
        return function () {
            _this.onDisconnected();
        };
    };
    Connectable.prototype.onConnected = function () { };
    Connectable.prototype.onDisconnected = function () {
        var _a;
        (_a = this.scheduler) === null || _a === void 0 ? void 0 : _a.clear();
        this._connector = null;
    };
    Connectable.prototype.emit = function (value) {
        var _this = this;
        if (!this._isConnected)
            return;
        var task = function () {
            var _a;
            (_a = _this._connector) === null || _a === void 0 ? void 0 : _a.call(_this, value);
        };
        if (this.scheduler) {
            this.scheduler.schedule(task);
        }
        else {
            task();
        }
    };
    return Connectable;
}());
export { Connectable };
